import { FutureDevelopmentPlaceholder } from "features/common/ui/FutureDevelopmentPlaceholder"

export const FavoritesPage = () => {
  return (
    <FutureDevelopmentPlaceholder />
  )
} 